import { render, staticRenderFns } from "./crowded-consent-url.vue?vue&type=template&id=1c1562e6&scoped=true&"
import script from "./crowded-consent-url.vue?vue&type=script&lang=js&"
export * from "./crowded-consent-url.vue?vue&type=script&lang=js&"
import style0 from "./crowded-consent-url.vue?vue&type=style&index=0&id=1c1562e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1562e6",
  null
  
)

export default component.exports